export const mixpanelEvents = {
  methods: {
    gtmViewEvent(event) {
      window.dataLayer = window.dataLayer || [];
      if (typeof window.dataLayer !== 'undefined') {
        var
          origin
        origin =
          document.referrer.indexOf('www.wegow.com') !== -1 ?
            'web_url' :
            document.referral !== '' ?
              document.referral :
              'direct'

        window.dataLayer.push({
          event: 'viewEvent',
          event_id: event.id.toString(),
          name: event.title,
          type: event.type,
          wegow_city: event.city.name,
          wegow_country: event.city.country,
          date: event.start_date,
          origin: origin
        });
      }
    }
  }
}
